import React, { memo, useEffect, useState } from 'react';

import { webViewCanvasCommands } from '../webViewCanvasUtils';
import BodySiteCanvas from '../../canvas/bodySiteCanvas/BodySiteCanvas.web';
import env from '../../../constants/env';

const isLandscape = false;

const WebViewBodySiteCanvas = () => {

	const [data, setData] = useState({});
	const [isLoading, setIsLoading] = useState(true);

	const onClose = () => {
		const message = JSON.stringify({
			type: webViewCanvasCommands.close,
		});
		if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(message);
	};

	const save = async (data) => {
		const message = JSON.stringify({
			type: webViewCanvasCommands.save,
			data,
		});
		if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(message);
	};
	const update = async (data) => {
		const message = JSON.stringify({
			type: webViewCanvasCommands.update,
			data,
		});
		if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(message);
	};

	useEffect(() => {
		try {
			const modalTypeDiv = document.getElementById('modalTypeDiv');
			const analysisDataFrontDiv = document.getElementById('analysisDataFrontDiv');
			const analysisDataBackDiv = document.getElementById('analysisDataBackDiv');
			const tbsaFormulaDiv = document.getElementById('tbsaFormulaDiv');
			const fluidResuscitationFormulaDiv = document.getElementById('fluidResuscitationFormulaDiv');
			const eocDiv = document.getElementById('eocDiv');
			const conditionDiv = document.getElementById('conditionDiv');
			const bodySiteDiv = document.getElementById('bodySiteDiv');

			const modalType = modalTypeDiv ? modalTypeDiv.innerText : undefined;
			const analysisDataFront = analysisDataFrontDiv ? JSON.parse(decodeURIComponent(analysisDataFrontDiv.innerText)) : undefined;
			const analysisDataBack = analysisDataBackDiv ? JSON.parse(decodeURIComponent(analysisDataBackDiv.innerText)) : undefined;
			const tbsaFormula = tbsaFormulaDiv ? tbsaFormulaDiv.innerText : undefined;
			const fluidResuscitationFormula = fluidResuscitationFormulaDiv ? fluidResuscitationFormulaDiv.innerText : undefined;
			const eoc = eocDiv ? JSON.parse(decodeURIComponent(eocDiv.innerText)) : undefined;
			const condition = conditionDiv ? JSON.parse(decodeURIComponent(conditionDiv.innerText)) : undefined;
			const bodySite = bodySiteDiv ? JSON.parse(decodeURIComponent(bodySiteDiv.innerText)) : undefined;

			const localData = {
				modalType,
				analysisDataFront,
				analysisDataBack,
				tbsaFormula,
				fluidResuscitationFormula,
				eoc,
				condition,
				bodySite,
			};
			setData(localData);
			setTimeout(() => {
				if(modalTypeDiv) modalTypeDiv.remove();
				if(analysisDataFrontDiv) analysisDataFrontDiv.remove();
				if(analysisDataBackDiv) analysisDataBackDiv.remove();
				if(tbsaFormulaDiv) tbsaFormulaDiv.remove();
				if(fluidResuscitationFormulaDiv) fluidResuscitationFormulaDiv.remove();
				if(eocDiv) eocDiv.remove();
				if(conditionDiv) conditionDiv.remove();
				if(bodySiteDiv) bodySiteDiv.remove();
				setIsLoading(false);
				const message = JSON.stringify({ type: webViewCanvasCommands.loaded });
				if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(message);
			}, 100);
		}
		catch (err) {
			if (env.NODE_ENV === 'local') window.alert(err);
			else window.alert('Error Loading Canvas');
		}

	}, []);

	return (
		<>
			{!isLoading && <BodySiteCanvas
				onClose={onClose}
				modalType={data.modalType}
				analysisDataFront={data.analysisDataFront}
				analysisDataBack={data.analysisDataBack}
				setAnalysisDataFront={data.setAnalysisDataFront}
				setAnalysisDataBack={data.setAnalysisDataBack}
				tbsaFormula={data.tbsaFormula}
				fluidResuscitationFormula={data.fluidResuscitationFormula}
				eoc={data.eoc}
				condition={data.condition}
				bodySite={data.bodySite}
				isLandscape={isLandscape}
				save={save}
				update={update}
			/>}
		</>
	);
};

export default memo(WebViewBodySiteCanvas);